import React from "react"
import useBrandInfo from "@hooks/dataHooks/useBrandInfo"
import GGFXTransform from "@common/stb-jamstack-ggfxclient/module/components/ggfx-transform"
import NoImage from "../../images/noImage.png"
// import ImageTransform from "../../common/ggfx-client/module/components/image-transform"

const GGFXImage = ({
  ImageSrc,
  altText,
  className,
  imagename,
  imagetransforms,
  renderer,
  lazyLoading,
  strapiID,
  ...props
}) => {
  const { name } = useBrandInfo()

  if (ImageSrc && ImageSrc.url) {
    const imageURL = ImageSrc.url

    const currentAltText = ImageSrc.alternativeText
      ? ImageSrc.alternativeText
      : altText || "image"

    const lazyText =
      typeof lazyLoading === "undefined" || lazyLoading === true ? "lazy" : ""

    return imagename ? (
      // <ImageTransform
      //   imagesources={imageURL}
      //   renderer={renderer}
      //   imagename={imagename}
      //   attr={{
      //     className,
      //     alt: `${currentAltText} - ${name}`,
      //     loading: lazyText,
      //   }}
      //   imagetransformresult={imagetransforms}
      //   id={strapiID}
      // />
      <GGFXTransform
        mediaUrl={imageURL}
        renderer={renderer}
        transformConfigName={imagename}
        attr={{
          className,
          alt: `${currentAltText} - ${name}`,
          loading: lazyText,
        }}
        preResult={imagetransforms}
        id={strapiID}
      />
    ) : (
      <img
        src={imageURL}
        alt={`${currentAltText} - ${name}`}
        {...props}
        className={className}
      />
    )
  }
  return (
    <img src={NoImage} alt={`${altText} - ${name}`} className={className} />
  )
}
export default GGFXImage
